import queryString from "query-string";

import {
  ClientSort,
  JourneyAnchors,
  NavigationItem,
  TeamRole,
} from "../../constants";
import {
  COACH_CLIENTS_ACTIVE_ROUTE,
  COACH_CLIENTS_ARCHIVED_ROUTE,
  COACH_CLIENTS_FORMS_ROUTE,
  COACH_CLIENTS_PENDING_ROUTE,
  COACH_CLIENTS_TAGS_ROUTE,
} from "../../routes/routes";
import { CoachClientsCount } from "../../contexts/CoachTabsContext";
import { Box, Skeleton } from "@mui/material";
import React from "react";
import InlineCounter from "../loading/InlineCounter";

export const clientsNavigation = (
  count?: CoachClientsCount,
  teamRole?: string,
): NavigationItem[] => {
  const query: any = () => ({
    // sort: queryString.parse(window.location.search).sort || ClientSort.NAME_ASC,
    sort: "",
    tag: "",
  });

  return [
    {
      name: "Active",
      link: COACH_CLIENTS_ACTIVE_ROUTE,
      query,
    },
    ...(teamRole === TeamRole.OWNER
      ? [
          {
            name: (
              <Box className={JourneyAnchors.CLIENTS_PENDING}>
                <InlineCounter
                  count={count.pending}
                  label="Pending"
                  loading={!count.pending && count.pending !== 0}
                />
              </Box>
            ),
            link: COACH_CLIENTS_PENDING_ROUTE,
            query,
          },
        ]
      : []),
    {
      name: <Box className={JourneyAnchors.CLIENTS_ARCHIVED}>Archived</Box>,
      link: COACH_CLIENTS_ARCHIVED_ROUTE,
      query,
    },
    {
      name: <Box className={JourneyAnchors.CLIENTS_FORMS}>Forms</Box>,
      link: COACH_CLIENTS_FORMS_ROUTE,
      query: () => ({}),
    },
    {
      name: "Tags",
      link: COACH_CLIENTS_TAGS_ROUTE,
      query: () => ({}),
    },
  ];
};
